import { CheckCircleIcon, IconWrap, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { CardFooter } from '@spa/scenes/Plannings/components'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import React from 'react'
import type { FC } from 'react'

type Props = {
  shift: ShiftModel
}
const ShiftChecked: FC<Props> = ({ shift }) => {
  const { t } = usePlanningTranslation()

  if (!shift.validated_at) {
    return null
  }

  return (
    <CardFooter.ActionItem>
      <Tooltip
        label={t('weekly.card.shiftValidated')}
        data-testid='shift-checked'
      >
        <IconWrap icon={<CheckCircleIcon />} size='s' />
      </Tooltip>
    </CardFooter.ActionItem>
  )
}

export default ShiftChecked
